import { Step } from './../Enuns/step.enum'

export const stepOptions = Object.entries(Step)
  .filter(([key]) => key !== 'ENTREGUE') // Remove ENTREGUE das opções
  .map((cat) => ({
    label: cat[1],
    value: cat[0],
  }))
